import { cloneDeep } from 'lodash'

import { initialAdminPortalState } from '~/features/admin/store'
import { initialAgentState } from '~/features/agents/store'
import { initialChatbotState } from '~/features/chatbot/store'
import { initialConversationState } from '~/features/conversations/store'
import { initialOrganizationState } from '~/features/organizations/store'
import { initialPortalAlertsState } from '~/features/portalAlerts/store'
import { initialSettingsState } from '~/features/settings/store'
import { initialUIElementsSessionState } from '~/features/ui/sessionStore'
import { initialUIElementsState } from '~/features/ui/store'
import { initialUserState } from '~/features/user/store'
import EStoreStateKeys from '~/models/store'

export const storeInitialValues = () => {
  return {
    [EStoreStateKeys.user]: cloneDeep(initialUserState),
    [EStoreStateKeys.adminPortal]: cloneDeep(initialAdminPortalState),
    [EStoreStateKeys.settings]: cloneDeep(initialSettingsState),
    [EStoreStateKeys.chatbot]: cloneDeep(initialChatbotState),
    [EStoreStateKeys.conversation]: cloneDeep(initialConversationState),
    [EStoreStateKeys.organization]: cloneDeep(initialOrganizationState),
    [EStoreStateKeys.UIElements]: cloneDeep(initialUIElementsState),
    [EStoreStateKeys.portalAlerts]: cloneDeep(initialPortalAlertsState),
    syncPathUpdatedAt: {},
  }
}

export const sessionStoreInitialValues = () => {
  return {
    [EStoreStateKeys.agent]: cloneDeep(initialAgentState),
    [EStoreStateKeys.UIElements]: cloneDeep(initialUIElementsSessionState),
  }
}
